export const SET_ROUTEBACK = 'SET_ROUTEBACK'
export const SET_WINDOWWIDTH = 'SET_WINDOWWIDTH'
